import type { TocLink } from "../../utils/api-types";
import * as styles from "./TableOfContents.css";

export const TOC_TITLE_TEXT = "On This Page";

export interface TableOfContentsProps {
  data: TocLink[];
  isOpen?: boolean;
}

export const TableOfContents = ({ data = [], isOpen = true }: TableOfContentsProps) => {
  if (!data.length) return null;
  return (
    <details aria-labelledby="label-toc-sum" className={``} open={isOpen}>
      <summary className={`text-xs font-bold py-2 cursor-pointer`} id="label-toc-sum">
        {TOC_TITLE_TEXT}
      </summary>
      <div className={`pb-2 border-t border-dotted border-current`}>{renderLinks(data)}</div>
    </details>
  );
};

const renderLinks = (data: TocLink[]) => {
  return (
    <ol className={`${styles.list} space-y-2`}>
      {data.map((item) => (
        <li key={item.href}>
          <a
            className={`hover:text-e-color-onSurface focus:text-e-color-onSurface`}
            href={item.href}
          >
            {item.text}
          </a>
          {item.childLinks.length ? renderLinks(item.childLinks) : null}
        </li>
      ))}
    </ol>
  );
};
